import React from 'react';

const RoomAnywhereProduct = () => {
    return (
        <div className="room-anywhere-product p-6 bg-gray-600 text-white rounded-md shadow-md">
            <h1 className="text-xl font-bold text-center mb-4">RoomAnywhere Product Outline</h1>
            
            <section className="mb-2">
                <h2 className="text-lg font-semibold mb-2">Summary</h2>
                <p>RoomAnywhere is a versatile, modular invention with a humanitarian focus. Its innovative design bridges the gap between providing shelter for the homeless and offering flexible privacy solutions within homes, offices, and commercial spaces. This fosters a sense of dignity, security, and community empowerment. As a one-size-fits-all solution, RoomAnywhere is a uniquely conceptualized and innovative product.</p>
            </section>

            <section className="mb-2">
                <h2 className="text-lg font-semibold mb-2">Specifications</h2>
                <ul className="list-disc pl-6">
                    <li>Material: Steel Rods + Steel Structure Assembly Items (10 kg for basic version)</li>
                    <li>Alternate Material for Home Use: PVC Rods + PVC Structure Assembly Items (8 kg for basic version)</li>
                    <li>Rod and Double Sliding Channels: Circular and flat structural components</li>
                    <li>Shelf Life:
                        <ul className="list-disc pl-6">
                            <li>Personal Use: 36 to 60 months</li>
                            <li>Commercial Use: 24 to 36 months</li>
                        </ul>
                    </li>
                </ul>
                <p className="mt-2 text-sm">*Shelf life depends on handling and materials used.</p>
            </section>

            <section className="mb-2">
                <h2 className="text-lg font-semibold mb-2">Add-ons</h2>
                <ul className="list-disc pl-6">
                    <li>Side Covers - 2</li>
                    <li>Front Cover - 1</li>
                    <li>Back Cover - 1</li>
                    <li>Top Cover - 1</li>
                </ul>
            </section>

            <section className="mb-2">
                <h2 className="text-lg font-semibold mb-2">Accessories</h2>
                <p>Enhance RoomAnywhere's functionality and comfort with customizable accessories:</p>
                <ul className="list-disc pl-6">
                    <li>Adjustable mosquito nets and waterproof covers</li>
                    <li>Attachable lighting strips, mini fans, and additional covers</li>
                    <li>Platforms for laptops, study, and work</li>
                    <li>Mobile attachments, book organizers, and kids-friendly covers</li>
                    <li>Inflatable beds, sofas, and collapsible furniture</li>
                    <li>Smart features: AI automation and app integration (future enhancements)</li>
                </ul>
            </section>

            <section className="mb-2">
                <h2 className="text-lg font-semibold mb-2">Key Features</h2>
                <ul className="list-disc pl-6">
                    <li>Portability: Easy to transport and assemble in minutes</li>
                    <li>Adjustability: Customizable sizes from 4x4x4 ft to 10x10x10 ft (343 combinations)</li>
                    <li>Durability: Weather-resistant materials for indoor and outdoor use</li>
                    <li>Multi-functionality: Adaptable for residential, commercial, and recreational purposes</li>
                </ul>
            </section>

            <section className="mb-2">
                <h2 className="text-lg font-semibold mb-2">Future Enhancements</h2>
                <p>RoomAnywhere will incorporate advanced features such as app-based control and AI automation, providing seamless integration with electronic attachments and a personalized user experience.</p>
            </section>
        </div>
    );
};

export default RoomAnywhereProduct;
